import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChannelListQrCodeCell } from './channel-list-qr-code.cell';
import { ChannelListQrCodeHeader } from './channel-list-qr-code.header';

export const ChannelListQrCodeColumn: IdentifiedColumnDef<
  GatewayChannelWithChargePointInfoModel,
  GatewayChannelWithChargePointInfoModel['qrCode']
> = {
  enableSorting: false,
  header: ChannelListQrCodeHeader,
  cell: ChannelListQrCodeCell,
};
